// fabric (~90 KB gz) stays out of the boot-time mapping bundle: the editor
// awaits loadFabric() on init, sync store mutations read the cached namespace.
import type { fabric as FabricNamespace } from 'fabric';

export type Fabric = typeof FabricNamespace;

let cached: Fabric | undefined;

export async function loadFabric(): Promise<Fabric> {
  cached ??= (await import('fabric')).fabric;
  return cached;
}

export function getFabric(): Fabric {
  if (!cached) throw new Error('[pdf-editor] fabric not loaded — await loadFabric() first');
  return cached;
}
